module.exports = __webpack_public_path__ + "img/ing.3504f891.gif";